import AmexDynamicTermsB2B from './AmexDynamicTermsB2B';

export default AmexDynamicTermsB2B;
